export type DailyStrikeScreenProps = {
  rewardPasses: number;
  onGoBack?: () => void;
};

export type DailyStrikeScreenModel = {
  rewardPasses: number;
  onGoBack?: () => void;
};

export function createDailyStrikeScreenModel(
  props: DailyStrikeScreenProps,
): DailyStrikeScreenModel {
  return {
    rewardPasses: Math.max(0, Math.floor(props.rewardPasses)),
    onGoBack: props.onGoBack,
  };
}
